import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { PermitsApprovalsService } from '@qaroni-app/permits/services/permits-approvals.service';
import { PermitApprovalCounter } from '@qaroni-app/permits/types/permit-approval-counter';

@Component({
  selector: 'qaroni-my-pending-absences-widget',
  templateUrl: './my-pending-absences-widget.component.html',
  styleUrl: './my-pending-absences-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MyPendingAbsencesWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private permitsApprovalsService = inject(PermitsApprovalsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  private companyID = 0;
  public $count = signal(0);

  private counter$ = this.permitsApprovalsService.counter$;
  private params$ = this.route.paramMap;

  public pluralMapping = {
    '=1': $localize`Permiso/Ausencia pendiente de mi aprobación`,
    other: $localize`Permiso/Ausencias pendientes de mi aprobación`,
  };

  ngOnInit(): void {
    this.subs.add(this.counter$.subscribe(this.getCounter));
    this.subs.add(this.params$.subscribe(this.getParamMaps));
  }

  public goToApprovals(): void {
    this.router.navigate([
      '/companies',
      this.companyID,
      'permits',
      'approvals',
    ]);
  }

  private getCounter = (counter: PermitApprovalCounter | null): void => {
    this.$count.set(counter?.myPendingCount ?? 0);
  };

  private getParamMaps = (params: ParamMap): void => {
    const paramCompanyID = params.get('companyID');

    if (paramCompanyID) {
      this.companyID = Number(paramCompanyID);
    }
  };
}
